export default {"src":"/_next/static/media/logo6.a8df560a.svg","height":117,"width":118};